export const API_URL = 'https://ddipi.diamondsdirect.com/v1';

// export const DIAMOND_API = 'https://stdapi.diamondsdirect.com';
export const DIAMOND_API = 'https://dapi.diamondsdirect.com';
// export const PRODUCT_API = 'https://ddstprodapi1.diamondsdirect.com';
export const PRODUCT_API = 'https://ddprodapi1.diamondsdirect.com';
export const MAGENTO_API = 'https://staging2.diamondsdirect.com/rest/V1';
// export const USER_API = 'https://dduserapi2.diamondsdirect.com';
export const USER_API = 'https://ddstuserapi1.diamondsdirect.com';
export const ORDERS_API = 'https://ddorderapi1.diamondsdirect.com';

export const HEADERS = {
	'Accept': 'application/json',
	'Content-Type': 'application/json'
};
export const FILE_HEADERS = {
	'Accept': 'application/json'
};




// WEBPACK FOOTER //
// ./src/constants/api.stage